<template>
  <div class="containerTable">
    <vxe-toolbar
      id="toolbarId_cu4"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button
          v-if="getLimit('feedback_search_button')"
          @click="funcFilter"
        >
          查询
        </el-button>
        <el-button
          v-if="getLimit('feedback_export_button')"
          @click="funcExport()"
        >
          导出
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      resizable
      stripe
      highlight-current-row
      border
      highlight-hover-row
      :loading="loading"
      height="80%"
      :data="tableData"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column>
        <vxe-table-column
          field="branchCode"
          title="承运主体"
          :formatter="formatterBranch"
          min-width="260"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.branchCode"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in branchList"
              :key="item.code"
              :label="item.groupName"
              :value="item.code"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="messager"
          title="用户姓名"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.messager"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="phone" title="电话" min-width="130" sortable />
        <template v-slot:header>
          <el-input
            v-model="listQuery.phone"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="content"
          title="反馈内容"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.content"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="gmtCreated"
          title="时间"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.gmtCreatedRange"
            type="daterange"
            value-format="yyyy-MM-dd"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="changeCreatedDate"
          />
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :page-sizes="Pagingconf"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
    <downloadData ref="downloadRef" />
  </div>
</template>
<script>
import { feedbackList } from "@/api/CustomerService";

export default {
  data() {
    return {
      exportObj: {
        exportUrl: "/ntocc-basic-api/feedback/exportFeedbackList", //导出接口
        name: "意见反馈"
      },
      message: "",
      loading: false,
      tableData: [],
      listQuery: {
        gmtCreatedRange: "",
        messager: "",
        phone: "",
        content: "",
        gmtCreatedStart: "",
        gmtCreatedEnd: "",
        pageNum: 1,
        pageSize: 20,
        total: 0
      },
      // 机构列表
      branchList: this.$store.state.components.branchList
    };
  },
  created() {
    this.findList();
  },
  methods: {
    findList() {
      this.loading = true;
      return new Promise(resolve => {
        feedbackList(this.listQuery).then(response => {
          this.tableData = response.data.records;
          this.listQuery.total = response.data.total;
          this.loading = false;
          resolve();
        });
      });
    },
    // 翻译机构
    formatterBranch({ cellValue }) {
      const item = this.branchList.find(item => item.code === cellValue);
      return item ? item.groupName : "";
    },
    handlePageChange({ currentPage, pageSize }) {
      this.listQuery.pageNum = currentPage;
      this.listQuery.limit = pageSize;
      this.findList();
    },
    changeCreatedDate(value) {
      if (value) {
        this.listQuery.gmtCreatedStart = value[0] + " 00:00:00";
        this.listQuery.gmtCreatedEnd = value[1] + " 23:59:59";
      } else {
        this.listQuery.gmtCreatedStart = "";
        this.listQuery.gmtCreatedEnd = "";
      }
    }
  }
};
</script>

<style></style>
